import { render } from "./GradeEdicao.vue?vue&type=template&id=4d3441e4&ts=true"
import script from "./GradeEdicao.vue?vue&type=script&lang=ts"
export * from "./GradeEdicao.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__